import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { motion } from 'framer-motion';
import { observer } from 'mobx-react';
import { useOccAssets } from '../../context/occ/hooks/use-occ-assets';
import { Icon } from '../icon';
const b = bemClassBuilder('v-expand-content-indicator');
/**
 * Renders an icon as an inline SVG.
 * See /src/icons/README.md for more details.
 */
export const ExpandContentIndicator = observer(props => {
    const { isExpanded, iconName, className } = props;
    const { expandContentIndicatorIconName } = useOccAssets();
    return (_jsx(motion.div, Object.assign({ className: b.block({ isExpanded }, className), animate: { rotate: isExpanded ? 180 : 0 }, transition: { type: 'spring', damping: 18 } }, { children: _jsx(Icon, { className: b.element('icon'), name: iconName || expandContentIndicatorIconName }) })));
});
ExpandContentIndicator.displayName = 'ExpandContentIndicator';
